import React from "react";
import { Button, Spinner } from "react-bootstrap";

const LoadingBtn = (props) => {

    return (
        <Button
            type="submit"
            className="btn-energo"
            disabled={props.isLoading}
        >
            {props.isLoading ?
                <Spinner
                    animation="grow"
                    size="sm"
                />
                :
                props.text
            }
        </Button>
    )
}

export default LoadingBtn;